<template>
  <div class="stepContent">
    <el-row>
      <el-col :span="9">
        <el-button class="cs-btnBillDetail" size="small" type="primary" @click="onViewBillDetail">查看账单</el-button>
        <workflowInfo :isReadOnly="dataIn.isCompleted" :isSupplement="dataIn.isSupplement" :dataIn="workflowInfoData" @hasTaxChange="onHasTaxChange"
          @isDoubleBonusPointChange="onIsDoubleBonusPointChange"></workflowInfo>
      </el-col>
      <el-col :span="12">
        <useBalanceEditor :isContinuePayment="dataIn.isContinuePayment" :isSupplement="dataIn.isSupplement" :isReadOnly="dataIn.isCompleted"
          :displayEnrollmentCount="dataIn.accountType == 2 || dataIn.accountType == 9" :bonusPointEditable="true" :cashDecreasedEditable="true"
          :bonusPointDisabled="bonusPointDisabled" :dataIn="usebalanceEditorData" @valueChange="onUseBalanceEditorValueChange"
          @valueChange2="onUseBalanceEditorValueChange2" @couponChange="onCouponChange"></useBalanceEditor>
      </el-col>
    </el-row>
    <div v-if="!dataIn.isSupplement && (dataIn.courseType === GLOBAL.courseType.university 
      || dataIn.courseType === GLOBAL.courseType.newStudentGuide) && dataIn.modelData">
      <el-row>
        <el-col :span="18">
          <hr>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <span class="cs-introducers-label">推荐人：</span>
          <div class="margin-left-20px cs-introducers-container">
            <el-select v-if="!dataIn.isCompleted" v-model="dataIn.modelData.introducerId" size="medium" placeholder="请选择推荐人">
              <el-option v-for="item in introducers" :key="item.Id" :label="item.Name" :value="item.Id">
              </el-option>
            </el-select>
            <span v-else>
              {{getIntroducerName()}}
            </span>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row>
      <el-col :span="18">
        <hr>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <workflow-image-list :data="workflowImageListData" :readonly="dataIn.isCompleted"></workflow-image-list>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="18">
        <hr>
      </el-col>
    </el-row>
    <div v-if="!dataIn.isCompleted && !dataIn.isSupplement && !isAllJoinWeChatGroup">
      <el-row>
        <el-col :span="18">
          进群验证：
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <joinWechatgroupValidator align="left" :showPhone="false" :dataIn="joinWeChatGroupValidateDataIn" @validateSuccess="onValidateSuccess">
          </joinWechatgroupValidator>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="18">
          <hr>
        </el-col>
      </el-row>
    </div>
    <el-row v-if="paymentMode == 0">
      <el-col>
        <paymentListView :dataList="accountModel.AccountPayments" :options="{ enableEdit: false, enableRemove: !dataIn.isCompleted && !dataIn.disabledRemove }"
          @item-remove="onAccountPaymentListItemRemove"></paymentListView>
      </el-col>
    </el-row>
    <el-row>
      <el-select v-if="!dataIn.isCompleted" v-model="paymentMode" size="medium" placeholder="请选择收费方式" @change="onPaymentModeChange">
        <el-option v-for="item in paymentModes" :key="item.key" :label="item.value" :value="item.key">
        </el-option>
      </el-select>
      <span v-else>{{ getPaymentModeText() }}</span>
    </el-row>
    <el-row>
      <el-col>&nbsp;</el-col>
    </el-row>
    <el-row v-if="paymentMode == 1">
      <autonomousPaymentSelector :excepts="[GLOBAL.enumPaymentType.emt, GLOBAL.enumPaymentType.creditCard]" :readonly="dataIn.isCompleted" v-model="paymentType"
        @change="onPaymentTypeChange" />
    </el-row>
    <el-row v-if="dataIn.isCompleted && paymentMode == 1 && !!paymentType && !!dataIn.modelData.qrCodeImage">
      <img :src="dataIn.modelData.qrCodeImage" />
    </el-row>
    <el-row v-if="paymentMode == 0 || dataIn.isSupplement">
      <el-col>
        <el-button v-if="!dataIn.isCompleted" :loading="isSavePayment" size="medium" :disabled="submitBtnDisable" :type="submitBtnClass"
          @click="onAddPaymentClick">{{ btnAddPaymentText }}</el-button>
      </el-col>
    </el-row>
    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="paymentEditorVisible" top="3vh">
      <paymentEditor :options="paymentEditorOptions" :data="paymentEditorData" @closeDialog="onAddPaymentEditorClose" @callback="onAddPaymentEditorCallback">
      </paymentEditor>
    </el-dialog>
    <el-dialog title="账单详情" :center="true" :close-on-click-modal="false" :visible.sync="billDetailDialogVisible" width="900px" top="5vh">
      <billDetail :dataIn="billDetailData" :studentPhone="this.usebalanceEditorData.memberModel.Phone"></billDetail>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.stepContent {
  padding: 20px 20px 0 20px;
}

.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;

    &.cs-introducers-label {
      padding-left: 0;
    }
  }
}
.cs-introducers-container {
  display: inline-block;
}
.cs-btnBillDetail{
  margin-bottom: 10px;
}
</style>

<script>
import {
  createAccountModel,
  saveAccount,
  removeAccountPayment,
  saveContinueAccountPayment,
} from "../../../service/finance.service.js";
import {
  getAccountByWorkflowId,
  saveAutonomousPaymentRecord,
} from "../../../service/enrollmentFee.service";
import workflowInfo from "./workflowInfo";
import useBalanceEditor from "../useBalanceEditor";
import paymentEditor from "../../common/paymentEditor";
import paymentListView from "../../common/paymentListView";
import workflowImageList from "@/components/common/workflowImageList";
import joinWechatgroupValidator from "@/components/common/JoinWeChatGroupValidator";
import billDetail from "./billDetail";
import { convertToFloat, getTax, toDecimal } from "../../../config/mUtils.js";
import { mixinCourseDiscount } from "./mixin";

export default {
  mixins: [mixinCourseDiscount],
  props: {
    bonusPointDisabled: {
      type: Boolean,
      default: false,
    },
    dataIn: {
      introducers: Array,
      isContinuePayment: Boolean,
      debt: Number,
      isSupplement: Boolean,
      isCompleted: Boolean,
      disabledRemove: Boolean,
      discountName: String,
      accountType: Number,
      courseType: Number,
      workflowId: Number,
      memberModel: Object,
      enrollmentCountUsed: Number,
      balanceInStore: Number,
      courseDiscountTotalPrice: Number,
      workflowRelatedDicountAmount: Number,
      workflowRelatedDicountDetail: String,
      studentAdvanceEnrollmentList: Array,
      advanceEnrollmentTotalPrice: Number,
      changeCourseDifferentPriceTotal: Number,
      changeCourseRefundPriceTotal: Number,
      //accountAmount:Number,
      priceSettings: Object,
      memberCardModel: {
        hasBuyMemberCard: Boolean,
        memberCardDiscountPrice: Number,
      },
      modelData: {
        enrollmentCount: Number,
        balance: Number,
        balanceTax: Number,
        bonusPoint: Number,
        cashDecreased: Number,
        couponDiscountDollar: Number,
        studentAdvanceEnrollmentAdditional: String,
        comment: String,
        isAutonomousPayment: Boolean,
        paymentType: Number,
        qrCodeImage: String,
        introducerId: Number,
        currentAutonomousPaymentRecordId: null,
      },
      couponData: {
        couponCode: String,
        couponDiscountValue: Number,
      },
      courseList: Array,
      isAllJoinWeChatGroup: Boolean,
      taxModel: Object,
    },
    workMode: String,
  },
  data() {
    return {
      submitBtnClass: "primary",
      submitBtnDisable: false,
      paymentEditorVisible: false,
      isAllJoinWeChatGroup: false,
      isSavePayment: false,
      workflowInfoData: {},
      usebalanceEditorData: {
        workflowId: 0,
        memberModel: {},
        enrollmentCountUsed: 0,
        accountAmount: 0,
        accountAmountWithTax: 0,
        priceSettings: {},
        modelData: {},
        modelUsedData: {},
        couponData: {},
        courseType: 1,
        studentAdvanceEnrollmentList: [],
      },
      paymentEditorOptions: {
        showTitle: true,
        allowPaidCount: 0,
        closeOnSaveDisabled: true,
        showAccountAmountLeft: true,
      },
      paymentEditorData: {},
      paymentList: [],
      accountpaymentListOptions: {},
      accountModel: {
        AccountPayments: [],
      },
      originalModel: {},
      workflowImageListData: {
        workflowId: 0,
      },
      joinWeChatGroupValidateDataIn: {
        phone: "",
      },
      paymentMode: 0,
      paymentModes: [
        { key: 0, value: "前台收费" },
        { key: 1, value: "学生自主缴费" },
      ],
      paymentType: null,
      introducers: [],
      billDetailDialogVisible: false,
      billDetailData: {
          discountNames:"",
          courseList: [],
          courseOriginalPrice: 0,
          courseTotalDiscountPrice: 0,
          courseTotalDecreaseAmount: 0,
          workflowRelatedDicountAmount: 0,
          balance: 0,
          bonusPointAmount: 0,
          enrollmentCountAmount: 0,
          accountDiscountAmount: 0,
          taxModel: {
            hasTax: false,
            taxRate: 0,
            courseTotalTax: 0
          },
          accountAmount: 0,
        },
    };
  },
  components: {
    billDetail,
    workflowInfo,
    useBalanceEditor,
    paymentEditor,
    paymentListView,
    workflowImageList,
    joinWechatgroupValidator,
    autonomousPaymentSelector: () =>
      import("@/components/payApi/paymentSelector"),
  },
  computed: {
    btnAddPaymentText() {
      let outValue = "添加支付";

      if (this.dataIn.isSupplement && this.paymentMode === 1)
        outValue = "完成补款";

      return outValue;
    },
    totalPayment: function () {
      let total = 0;
      if (!!this.accountModel) {
        this.accountModel.AccountPayments.forEach((element) => {
          total += element.Amount + element.Tax;
        });
      }
      return total;
    },
    enrollmentCountAmount: function () {
      let value = 0;

      if (!!this.dataIn && !!this.dataIn.advanceEnrollmentTotalPrice) {
        value = this.dataIn.advanceEnrollmentTotalPrice;
      }

      return value;
    },
    bonusPointAmount: function () {
      let value = 0;
      if (!!this.dataIn && !!this.dataIn.modelData) {
        let bonusPoint = parseInt(this.dataIn.modelData.bonusPoint);
        value = this.__convertBonusPointToAmount(
          this.dataIn.priceSettings,
          bonusPoint
        );
      }
      return value;
    },
    //课程总应付
    courseTotalPrice: function () {
      let value = 0;
      if (!!this.dataIn && !!this.dataIn.courseList) {
        this.dataIn.courseList.forEach((element) => {
          value += element.priceData.subtotal;
        });
      }

      return value;
    },
    //总课程折扣价,不含补看视频
    courseTotalDiscountPrice: function () {
      let value = 0;
      this.dataIn.courseList.forEach((element) => {
        value += element.priceData.discountPrice;
      });
      return value;
    },
    //学生代理折后总课程价
    courseTotalCouponDiscountPrice: function () {
      let value = 0;
      this.dataIn.courseList.forEach((element) => {
        value += element.priceData.couponDiscountPrice;
      });
      return value;
    },
    //课程总原价
    courseTotalOriginalPrice: function () {
      let value = 0;
      this.dataIn.courseList.forEach((element) => {
        value += element.priceData.price;
      });
      return value;
    },
    //总看视频价格
    supplementVideoTotalPrice: function () {
      let value = 0;
      this.dataIn.courseList.forEach((element) => {
        value += element.priceData.supplementVideoPrice;
      });
      return value;
    },
    //换课总差价
    // changeCourseDifferentPriceTotal: function() {
    //   let value = 0;
    //   this.dataIn.courseList.forEach(element => {
    //     if (!!element.priceData.changeCourseDifferentPrice){
    //       value += element.priceData.changeCourseDifferentPrice;
    //     }
    //   });
    //   return value;
    // },
    //退款总差价
    // changeCourseRefundPriceTotal: function() {
    //   let value = 0;
    //   this.dataIn.courseList.forEach(element => {
    //     if (!!element.priceData.changeCourseRefundPrice){
    //       value += element.priceData.changeCourseRefundPrice;
    //     }

    //   });
    //   return value;
    // },
    //课程和会员总应付
    accountAmountTotal: function () {
      let value = this.courseTotalPrice;
      if (!!this.dataIn && !!this.dataIn.courseDiscountTotalPrice) {
        value = this.dataIn.courseDiscountTotalPrice;
      }
      if (!!this.dataIn && !!this.dataIn.memberCardModel) {
        value = value + this.dataIn.memberCardModel.memberCardDiscountPrice;
      }
      return value;
    },
    //使用总余额和占位(含税)
    balanceTotal: function () {
      let value = 0;
      if (!!this.dataIn && !!this.dataIn.modelData) {
        value =
          this.enrollmentCountAmount +
          convertToFloat(this.dataIn.modelData.balance);
      }
      return value;
    },
    //总优惠
    discountTotal: function () {
      let value = 0;
      if (!!this.dataIn && !!this.dataIn.modelData) {
        value =
          this.bonusPointAmount +
          `${this.dataIn.modelData.cashDecreased}`.toNumber().toFixedEx(2) +
          `${this.dataIn.modelData.couponDiscountDollar}`
            .toNumber()
            .toFixedEx(2) +
          this.dataIn.workflowRelatedDicountAmount;
      }
      return value;
    },
    //课程总价优惠
    courseTotalDecreaseAmount: function () {
      let courseDiscountTotalPrice = 0;
      if (!!this.dataIn && !!this.dataIn.courseDiscountTotalPrice) {
        courseDiscountTotalPrice = this.dataIn.courseDiscountTotalPrice;
      }
      let value = 0;
      if (courseDiscountTotalPrice > 0)
        value = this.courseTotalPrice - courseDiscountTotalPrice;
      if (value < 0) {
        value = 0;
      }

      return value;
    },
    //扣除优惠和余额后总应付
    accountDiscountAmount: function () {
      let value = 0;
      if (!!this.dataIn) {
        value =
          this.accountAmountTotal -
          this.discountTotal +
          this.dataIn.changeCourseRefundPriceTotal;
      }
      return value;
    },
    //总税费
    courseTotalTax: function () {
      let value = 0;
      if (!!this.dataIn && !!this.dataIn.taxModel) {
        if (this.dataIn.taxModel.hasTax) {
          value = this.accountDiscountAmount * this.dataIn.taxModel.taxRate;
        }
        this.$set(this.dataIn.taxModel, "courseTotalTax", value);
      }

      return value;
    },
    accountDiscountAmountWithTax: function () {
      return toDecimal(this.accountDiscountAmount + this.courseTotalTax);
    },
    //总应付
    accountAmount: function () {
      let balanceInStore = 0;
      if (!!this.dataIn && !!this.dataIn.balanceInStore) {
        balanceInStore = this.dataIn.balanceInStore;
      }

      let value =
        this.accountDiscountAmountWithTax + balanceInStore - this.balanceTotal;
      return value;
    },
    accountAmountTax: function () {
      let value = 0;
      if (!!this.dataIn && !!this.dataIn.taxModel) {
        if (this.dataIn.taxModel.hasTax && this.accountAmount > 0) {
          value = getTax(this.accountAmount, this.dataIn.taxModel.taxRate);
        }
      }
      return value;
    },
    accountAmountWithoutTax: function () {
      let value = this.accountAmount - this.accountAmountTax;
      if (value < 0) {
        value = 0;
      }
      return value;
    },
    accountAmountLeft: function () {
      if (this.dataIn.isContinuePayment) {
        return this.dataIn.debt;
      }

      let value = this.accountAmount - this.totalPayment;
      if (value < 0) {
        value = 0;
      }
      return value;
    },
    autonomousPaymentTypes() {
      let retValue = this.GLOBAL.enumPaymentType.getOptionsForCheckpay([
        this.GLOBAL.enumPaymentType.emt,
        this.GLOBAL.enumPaymentType.creditCard,
      ]);
      return retValue;
    },
  },
  created() {
    this.init();
  },
  updated() {},
  methods: {
    init() {
      if (
        !!this.dataIn &&
        !!this.dataIn.priceSettings &&
        !!this.dataIn.memberCardModel &&
        !!this.dataIn.courseList &&
        this.dataIn.memberModel
      ) {
        this.isAllJoinWeChatGroup = this.dataIn.isAllJoinWeChatGroup;
        this.adEnrollmentPrice = this.dataIn.priceSettings.adEnrollmentPrice;
        if (this.dataIn.courseType == 3) {
          this.adEnrollmentPrice =
            this.dataIn.priceSettings.trainingAdEnrollmentPrice;
        }

        if (this.dataIn.modelData.isAutonomousPayment) {
          this.paymentMode = 1;
        } else {
          this.paymentMode = 0;
        }

        if (
          this.autonomousPaymentTypes.contains(
            this.dataIn.modelData.paymentType,
            (item, value) => item.value === value
          )
        ) {
          this.paymentType = this.dataIn.modelData.paymentType;
        } else {
          this.paymentType = null;
        }

        let modelData = {};
        let modelUsedData = {};
        if (this.dataIn.isSupplement) {
          this.originalModel = JSON.parse(
            JSON.stringify(this.dataIn.modelData)
          );
          modelUsedData = JSON.parse(JSON.stringify(this.dataIn.modelData));
          modelData = {
            enrollmentCount: 0,
            balance: 0,
            balanceTax: 0,
            bonusPoint: 0,
            cashDecreased: 0,
            studentAdvanceEnrollmentAdditional:
              this.dataIn.modelData.studentAdvanceEnrollmentAdditional,
            comment: "",
          };
        } else {
          modelData = JSON.parse(JSON.stringify(this.dataIn.modelData));
          modelUsedData = {
            enrollmentCount: 0,
            balance: 0,
            balanceTax: 0,
            bonusPoint: 0,
            cashDecreased: 0,
            couponDiscountDollar: 0,
            studentAdvanceEnrollmentAdditional: "",
            comment: "",
          };
        }

        this.usebalanceEditorData = {
          workflowId: this.dataIn.workflowId,
          memberModel: this.dataIn.memberModel,
          enrollmentCountUsed: this.dataIn.enrollmentCountUsed,
          accountAmount: toDecimal(this.accountDiscountAmount),
          accountAmountWithTax: toDecimal(this.accountDiscountAmountWithTax),
          balanceInStore: this.dataIn.balanceInStore,
          priceSettings: this.dataIn.priceSettings,
          modelData: modelData,
          modelUsedData: modelUsedData,
          courseType: this.dataIn.courseType,
          studentAdvanceEnrollmentList:
            this.dataIn.studentAdvanceEnrollmentList,
          advanceEnrollmentTotalPrice: this.dataIn.advanceEnrollmentTotalPrice,
          couponData: this.dataIn.couponData,
          //modelData:this.dataIn.modelData
        };

        this.joinWeChatGroupValidateDataIn = {
          phone: this.usebalanceEditorData.memberModel.Phone,
        };

        this.loadAccountModel();
        this.loadWorkflowInfoData();

        this.workflowImageListData = {
          workflowId: this.dataIn.workflowId,
        };
      } else {
        this.workflowInfoData = {
          discountName: "",
          courseType: this.dataIn.courseType,
          courseList: [],
          memberCardModel: {
            hasBuyMemberCard: false,
            memberCardDiscountPrice: 0,
          },
          memberCardPrice: 0,
          courseOriginalPrice: 0,
          courseTotalPrice: 0,
          courseTotalDiscountPrice: 0,
          supplementVideoTotalPrice: 0,
          enrollmentCountAmount: 0,
          balance: 0,
          balanceTax: 0,
          bonusPointAmount: 0,
          cashDecreased: 0,
          couponDiscountDollar: 0,
          accountDiscountAmount: 0,
          accountAmount: 0,
          totalPayment: 0,
          balanceInStore: 0,
          courseTotalDecreaseAmount: 0,
          workflowRelatedDicountAmount: 0,
          workflowRelatedDicountDetail: "",
          studentAdvanceEnrollmentAdditional: "",
          comments: "",
          taxModel: {
            hasTaxSetting: false,
            hasTax: false,
            courseTotalTax: 0,
            taxRate: 0,
          },
          isContinuePayment: false,
          debt: 0,
          isMember: false,
        };
      }
    },
    loadWorkflowInfoData() {
      this.workflowInfoData = {
        courseType: this.dataIn.courseType,
        discountName: this.dataIn.discountName,
        courseList: this.dataIn.courseList,
        memberCardModel: this.dataIn.memberCardModel,
        //hasBuyMemberCard:this.dataIn.memberCardModel.hasBuyMemberCard,
        //memberCardDiscountPrice:this.dataIn.memberCardModel.memberCardDiscountPrice,
        memberCardPrice: this.dataIn.priceSettings.memberCardPrice,
        courseOriginalPrice: this.courseTotalOriginalPrice,
        courseTotalPrice: this.courseTotalPrice,
        courseTotalDiscountPrice: this.courseTotalDiscountPrice,
        supplementVideoTotalPrice: this.supplementVideoTotalPrice,
        changeCourseDifferentPriceTotal:
          this.dataIn.changeCourseDifferentPriceTotal,
        changeCourseRefundPriceTotal: this.dataIn.changeCourseRefundPriceTotal,
        enrollmentCountAmount: this.enrollmentCountAmount,
        balance: convertToFloat(this.dataIn.modelData.balance),
        balanceTax: convertToFloat(this.dataIn.modelData.balanceTax),
        bonusPointAmount: this.bonusPointAmount,
        cashDecreased: convertToFloat(this.dataIn.modelData.cashDecreased),
        couponDiscountDollar: parseInt(
          this.dataIn.modelData.couponDiscountDollar
        ),
        accountDiscountAmount: this.accountDiscountAmount,
        accountAmount: this.accountAmount,
        totalPayment: this.totalPayment,
        balanceInStore: this.dataIn.balanceInStore,
        courseTotalDecreaseAmount: this.courseTotalDecreaseAmount,
        workflowRelatedDicountAmount: this.dataIn.workflowRelatedDicountAmount,
        workflowRelatedDicountDetail: this.dataIn.workflowRelatedDicountDetail,
        studentAdvanceEnrollmentAdditional:
          this.dataIn.modelData.studentAdvanceEnrollmentAdditional,
        comments: this.dataIn.modelData.comment,
        taxModel: this.dataIn.taxModel,
        isContinuePayment: this.dataIn.isContinuePayment,
        debt: this.dataIn.isContinuePayment
          ? this.accountModel.Debt
          : this.dataIn.debt,
        courseTotalCouponDiscountPrice: this.courseTotalCouponDiscountPrice,
        hasCouponDiscount:
          !!this.dataIn.couponData && !!this.dataIn.couponData.couponCode,
        isMember: this.dataIn.memberModel.IsMember,
      };
    },
    loadAccountModel() {
      if (
        !!this.dataIn &&
        !!this.dataIn.memberModel.StudentId &&
        !!this.dataIn.workflowId
      ) {
        getAccountByWorkflowId(
          this.dataIn.memberModel.StudentId,
          this.dataIn.workflowId
        ).then((result) => {
          if (!!result && result.success) {
            this.accountModel = result.data;
            this.showError = false;
            this.errorMessage = "";
          } else {
            this.initAccountModel();
            this.showError = true;
            this.errorMessage = result.message;
          }

          this.loadWorkflowInfoData();
        });
      } else {
        this.initAccountModel();
      }
    },
    async saveAccountModel() {
      this.accountModel.Amount = this.accountAmountWithoutTax;
      this.accountModel.AmountTax = this.accountAmountTax;
      this.isSavePayment = true;
      this.submitBtnDisable = true;
      this.$emit("savePaymentStart");
      let result = await saveAccount(this.accountModel);
      if (!!result && result.success) {
        this.loadAccountModel();
        //this.checkCompleteAvailable();
      }

      this.isSavePayment = false;
      this.submitBtnDisable = false;
      this.$emit("savePaymentEnd");
    },
    async saveAutonomousPaymentRecordToServer() {
      this.isSavePayment = true;
      this.submitBtnDisable = true;
      let id = !!this.dataIn.modelData.currentAutonomousPaymentRecordId
        ? this.dataIn.modelData.currentAutonomousPaymentRecordId
        : 0;
      let data = {
        Id: id,
        EnrollmentFeeWorkflowId: this.dataIn.workflowId,
        IsSupplement: this.dataIn.isSupplement,
        PaymentType: this.paymentType,
        PaymentAmount: this.accountAmountLeft,
        Status: 1,
      };

      try {
        let result = await saveAutonomousPaymentRecord(data);

        if (!!result) {
          if (result.success) {
            this.dataIn.modelData.qrCodeImage = result.data.QRCodeImage;
            this.dataIn.modelData.currentAutonomousPaymentRecordId =
              result.data.Id;
            this.dataIn.isCompleted = true;

            this.$message.success("保存自主缴费记录成功！");
          } else {
            this.$message.error(`保存自主缴费记录失败！${result.message}`);
          }
        }
      } catch (error) {
        this.$message.error(`保存自主缴费记录失败！`);
      }
      this.isSavePayment = false;
      this.submitBtnDisable = false;
    },
    getAccountAmount() {
      return this.accountAmountLeft;
    },
    checkUseBalanceEditorSaved() {
      let modelData = this.usebalanceEditorData.modelData;
      return (
        !modelData.__bonusPointChanged && !modelData.__cashDecreasedChanged
      );
    },
    checkCompleteAvailable() {
      return true;

      let isCompleteAvailable = false;
      let total = this.accountDiscountAmountWithTax;

      if (total > 0) {
        let percentage = (this.totalPayment + this.balanceTotal) / total;
        if (percentage >= 0.2) {
          isCompleteAvailable = true;
        }
      } else {
        isCompleteAvailable = true;
      }
      return isCompleteAvailable;
      //this.$emit("isCompleteAvailableChange", isCompleteAvailable);
    },
    async onUseBalanceEditorValueChange(result, isReduce) {
      let balance = 0;

      // let bonusPoint = 0;
      let enrollmentCount = 0;
      // let cashDecreased = 0;
      let studentAdvanceEnrollmentAdditional = "";
      if (!!result.balance) {
        balance = convertToFloat(result.balance);
      }
      let balanceTax = this.getTax(balance);

      // if (!!result.bonusPoint) {
      //   bonusPoint = parseInt(result.bonusPoint);
      // }
      if (!!result.enrollmentCount) {
        enrollmentCount = parseInt(result.enrollmentCount);
      }

      if (!!result.studentAdvanceEnrollmentAdditional) {
        studentAdvanceEnrollmentAdditional =
          result.studentAdvanceEnrollmentAdditional;
      }

      if (this.dataIn.isSupplement) {
        if (isReduce) {
          this.$set(
            this.dataIn.modelData,
            "balance",
            this.originalModel.balance - balance
          );

          this.$set(
            this.dataIn.modelData,
            "balanceTax",
            this.originalModel.balanceTax - balanceTax
          );

          this.$set(
            this.dataIn.modelData,
            "enrollmentCount",
            this.originalModel.enrollmentCount - enrollmentCount
          );
        } else {
          this.$set(
            this.dataIn.modelData,
            "balance",
            balance + this.originalModel.balance
          );

          this.$set(
            this.dataIn.modelData,
            "balanceTax",
            balanceTax + this.originalModel.balanceTax
          );

          this.$set(
            this.dataIn.modelData,
            "enrollmentCount",
            enrollmentCount + this.originalModel.enrollmentCount
          );
        }
        this.$set(
          this.dataIn.modelData,
          "studentAdvanceEnrollmentAdditional",
          studentAdvanceEnrollmentAdditional
        );
        this.$set(this.dataIn.modelData, "comment", result.comment);
      } else {
        this.$set(this.dataIn.modelData, "balance", balance);
        this.$set(this.dataIn.modelData, "balanceTax", balanceTax);
        // this.$set(this.dataIn.modelData, "bonusPoint", bonusPoint);
        this.$set(this.dataIn.modelData, "enrollmentCount", enrollmentCount);
        // this.$set(this.dataIn.modelData, "cashDecreased", cashDecreased);
        this.$set(
          this.dataIn.modelData,
          "studentAdvanceEnrollmentAdditional",
          studentAdvanceEnrollmentAdditional
        );
        this.$set(this.dataIn.modelData, "comment", result.comment);
      }

      this.$set(
        this.usebalanceEditorData,
        "accountAmount",
        this.accountDiscountAmount
      );
      this.$set(
        this.usebalanceEditorData,
        "accountAmountWithTax",
        this.accountDiscountAmountWithTax
      );
      this.$nextTick(() => {
        this.loadWorkflowInfoData();
        this.$emit("save");
      });
    },
    onUseBalanceEditorValueChange2(result, isReduce) {
      let bonusPoint = 0;
      let bonusPointAmount = 0;
      let cashDecreased = 0;

      if (!!result.bonusPoint) {
        bonusPoint = `${result.bonusPoint}`.toNumber().toFixedEx(0);
        bonusPointAmount = this.__convertBonusPointToAmount(
          this.dataIn.priceSettings,
          bonusPoint
        );
      }
      if (!!result.cashDecreased) {
        cashDecreased = `${result.cashDecreased}`.toNumber().toFixedEx(2);
      }

      if (!this.dataIn.isSupplement) {
        this.$set(this.dataIn.modelData, "bonusPoint", bonusPoint);
        this.$set(this.dataIn.modelData, "cashDecreased", cashDecreased);
        this.$set(this.dataIn.modelData, "comment", result.comment);

        this.__reallocateCourseDiscount(
          this.dataIn.priceSettings,
          this.dataIn.courseList,
          bonusPoint,
          cashDecreased
        );

        this.$set(
          this.usebalanceEditorData,
          "accountAmount",
          this.accountDiscountAmount
        );
        this.$set(
          this.usebalanceEditorData,
          "accountAmountWithTax",
          this.accountDiscountAmountWithTax
        );
        this.$nextTick(() => {
          this.loadWorkflowInfoData();
          this.$emit("save");
        });
      }
    },
    onAddPaymentClick() {
      if (this.paymentMode === 1) {
        if (this.dataIn.isSupplement) {
          if (!!this.dataIn.modelData.currentAutonomousPaymentRecordId) {
            this.$confirm("已存在补款自主缴费记录，是否重新生成?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.saveAutonomousPaymentRecordToServer();
              })
              .catch(() => {});
          } else {
            this.saveAutonomousPaymentRecordToServer();
          }
        }
        return;
      }

      this.showAddPaymentEditor();
    },
    showAddPaymentEditor() {
      this.paymentEditorData = {
        accountAmountLeft: this.accountAmountLeft,
        hasTax: this.dataIn.taxModel.hasTax,
        taxRate: this.dataIn.taxModel.taxRate,
      };
      this.paymentEditorVisible = true;
    },
    onAddPaymentEditorClose() {
      this.paymentEditorVisible = false;
    },
    saveContinuePayment(result) {
      result.data.AccountId = this.accountModel.Id;
      this.accountModel.Amount = this.accountAmountWithoutTax;
      this.accountModel.AmountTax = this.accountAmountTax;
      this.isSavePayment = true;
      this.submitBtnDisable = true;
      saveContinueAccountPayment(result.data).then((r) => {
        if (!!r && r.success) {
          this.loadAccountModel();
        }
        this.isSavePayment = false;
        this.submitBtnDisable = false;
        this.paymentEditorVisible = false;
      });
    },
    onAddPaymentEditorCallback(result) {
      if (result.success) {
        if (!!this.workMode && this.workMode == "ContinuePayment") {
          if (result.data.TotalAmount > this.accountModel.Debt) {
            let msg = `付款金额 ${result.data.TotalAmount} 大于补款金额 ${this.accountModel.Debt}，确认继续吗?`;
            this.$confirm(msg, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.saveContinuePayment(result);
              })
              .catch(() => {
                self.loading = false;
              });
          } else {
            this.saveContinuePayment(result);
          }
        } else {
          this.accountModel.AccountPayments.push(result.data);
          this.saveAccountModel();
          this.paymentEditorVisible = false;
        }
      }
    },
    onAccountPaymentListItemRemove(data) {
      if (!!data && !!data.item && !!data.item.Id) {
        this.isSavePayment = true;
        this.submitBtnDisable = true;
        removeAccountPayment(data.item.Id, this.workMode).then((result) => {
          if (!result) {
            return;
          }
          if (result.success) {
            this.$message({
              message: "删除支付成功",
              type: "success",
            });
            this.accountModel.AccountPayments.splice(data.index, 1);
            this.saveAccountModel();
          } else {
            this.$message({
              message: "删除支付失败",
              type: "error",
            });
            this.isSavePayment = false;
            this.submitBtnDisable = false;
          }
        });
      }
    },
    onValidateSuccess() {
      let self = this;
      this.dataIn.courseList.forEach(function (item, index) {
        self.$set(item.modelData, "weChatGroupType", 1);
      });
      this.isAllJoinWeChatGroup = true;
      this.$emit("save");
    },
    initAccountModel() {
      this.accountModel = createAccountModel(this.dataIn.accountType);
      if (!!this.dataIn) {
        this.accountModel.WorkflowId = this.dataIn.workflowId;
        this.accountModel.StudentId = this.dataIn.memberModel.StudentId;
      }
      this.accountModel.Amount = this.accountAmountWithoutTax;
      this.accountModel.AmountTax = this.accountAmountTax;
    },
    getTax(value) {
      let tax = 0;
      if (
        !!this.dataIn &&
        !!this.dataIn.taxModel &&
        this.dataIn.taxModel.hasTax
      ) {
        let rate = this.dataIn.taxModel.taxRate;
        tax = getTax(value, rate);
      }
      return tax;
    },
    onHasTaxChange() {
      this.loadWorkflowInfoData();
      let balanceTax = this.getTax(this.dataIn.modelData.balance);
      this.$set(this.dataIn.modelData, "balanceTax", balanceTax);

      this.accountModel.AccountPayments.forEach((ele) => {
        if (this.dataIn.taxModel.hasTax) {
          ele.Tax = getTax(ele.TotalAmount, this.dataIn.taxModel.taxRate);
          ele.Amount = ele.TotalAmount - ele.Tax;
        } else {
          ele.Amount = ele.TotalAmount;
          ele.Tax = 0;
        }
      });
      this.usebalanceEditorData.accountAmount = toDecimal(
        this.accountDiscountAmount
      );
      this.usebalanceEditorData.accountAmountWithTax = toDecimal(
        this.accountDiscountAmountWithTax
      );
    },
    onIsDoubleBonusPointChange(value) {
      this.$emit("isDoubleBonusPointChange", value);
    },
    onPaymentModeChange() {
      if (this.paymentMode == 0) {
        this.dataIn.modelData.isAutonomousPayment = false;
      } else {
        this.dataIn.modelData.isAutonomousPayment = true;
      }
    },
    onPaymentTypeChange() {
      this.dataIn.modelData.paymentType = this.paymentType;
    },
    getPaymentModeText() {
      let item = this.paymentModes.find((i) => i.key == this.paymentMode);
      if (item) {
        return item.value;
      }
      return "";
    },
    onCouponChange(couponModel) {
      this.$emit("couponChange", couponModel);
      if (couponModel.couponCode) {
        this.workflowInfoData.hasCouponDiscount = true;
      } else {
        this.workflowInfoData.hasCouponDiscount = false;
      }
    },
    loadIntroducers() {
      if (this.dataIn && this.dataIn.introducers && this.dataIn.memberModel) {
        let groupNumber = this.dataIn.memberModel.UniversityGroupNumber;
        if (groupNumber) {
          this.introducers = this.dataIn.introducers.filter(
            (i) => i.UniversityGroup === groupNumber
          );
        } else {
          this.introducers = [];
        }
      } else {
        this.introducers = [];
      }
    },
    getIntroducerName() {
      if (
        this.dataIn &&
        this.dataIn.introducers &&
        this.dataIn.modelData &&
        this.dataIn.modelData.introducerId
      ) {
        let item = this.dataIn.introducers.find(
          (i) => i.Id === this.dataIn.modelData.introducerId
        );
        return item.Name;
      }
      return "";
    },
    onViewBillDetail(){
      this.reloadDataForBillDetail();
      this.billDetailDialogVisible = true;
    },
    reloadDataForBillDetail() {
      let newData = {
        discountNames: "",
        courseList: [],
        courseOriginalPrice: 0,
        courseTotalDiscountPrice: 0,
        courseTotalDecreaseAmount: 0,
        workflowRelatedDicountAmount: 0,
        balance: 0,
        bonusPointAmount: 0,
        enrollmentCountAmount: 0,
        enrollmentCountUsed: 0,
        accountDiscountAmount: 0,
        taxModel: {
          hasTax: false,
          taxRate: 0,
          courseTotalTax: 0
        },
        accountAmount: 0,
        balanceTotal: 0
      };
      
      if (!!this.dataIn){
        newData.discountNames = this.dataIn.discountName;
        newData.courseList = this.dataIn.courseList;
        if (!!this.dataIn.modelData && !!this.dataIn.modelData.studentAdvanceEnrollmentAdditional){
          let listAdvanceEnrollment = this.dataIn.modelData.studentAdvanceEnrollmentAdditional.split(",");
          newData.enrollmentCountUsed = listAdvanceEnrollment.length;
        }
        newData.balanceTotal = this.dataIn.memberModel.BalanceTotal;
      }
     
      // Use computed properties for prices
      newData.courseOriginalPrice = this.courseTotalOriginalPrice || 0;
      newData.courseTotalDiscountPrice = this.courseTotalDiscountPrice || 0;
      newData.courseTotalDecreaseAmount = this.courseTotalDecreaseAmount || 0;
      newData.accountDiscountAmount = this.accountDiscountAmount || 0;
      newData.workflowRelatedDicountAmount = this.dataIn.workflowRelatedDicountAmount || 0;
      
      // Calculate balance from modelData (only balance, not including enrollmentCount)
      newData.balance = convertToFloat(this.dataIn.modelData.balance) || 0;
      
      // Use computed properties for bonus point and enrollment count
      newData.bonusPointAmount = this.bonusPointAmount || 0;
      newData.enrollmentCountAmount = this.enrollmentCountAmount || 0;
      
      // Get cash decreased from modelData
      newData.CashDecreasedAmount = convertToFloat(this.dataIn.modelData.cashDecreased) || 0;
      
      // Get tax model from dataIn
      if (!!this.dataIn && !!this.dataIn.taxModel) {
        newData.taxModel.hasTax = this.dataIn.taxModel.hasTax || false;
        newData.taxModel.taxRate = this.dataIn.taxModel.taxRate || 0;
        newData.taxModel.courseTotalTax = this.courseTotalTax || 0;
      }
      newData.accountAmount = this.accountAmount || 0;

      this.billDetailData = newData;
    },
  },
  watch: {
    dataIn: function () {
      this.init();
    },
    "dataIn.memberModel": function (model) {
      if (!!this.usebalanceEditorData) {
        this.$set(this.usebalanceEditorData, "memberModel", model);
        this.joinWeChatGroupValidateDataIn = {
          phone: this.usebalanceEditorData.memberModel.Phone,
        };
      }
      this.loadIntroducers();
    },
    "dataIn.modelData.bonusPoint": function (newVal) {
      this.usebalanceEditorData.modelData.bonusPoint = newVal;
    },
    "dataIn.modelData.cashDecreased": function (newVal) {
      this.usebalanceEditorData.modelData.cashDecreased = newVal;
    },
    "dataIn.advanceEnrollmentTotalPrice": function (newVal, oldVal) {
      this.$set(
        this.usebalanceEditorData,
        "accountAmount",
        this.accountDiscountAmount
      );
      this.$set(
        this.usebalanceEditorData,
        "accountAmountWithTax",
        this.accountDiscountAmountWithTax
      );
    },
    "dataIn.introducers": function (newVal) {
      this.loadIntroducers();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/courseEnrollmentFee/workflowStep3.vue